import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import ArrowBackIcon from "@mui/icons-material/ArrowBackOutlined";
import ExpandIcon from "@mui/icons-material/OpenInFullOutlined";
import ShrinkIcon from "@mui/icons-material/CloseFullscreenOutlined";
import ModeIcon from "@mui/icons-material/ModeOutlined";
import AddIcon from "@mui/icons-material/AddOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";

const ViewModalHeader = ({
  isExpanded,
  setIsExpanded,
  handleCloseModal,
  isEditMode = false,
  handleEditButtonClick,
  handleCancel,
  handleDelete,
  isSaving,
  autosaveStatus,
  handleOpenAddModal,
}) => {
  return (
    <div className="w-full">
      <div className="relative flex items-center justify-between px-4 py-2">
        {/* Back Button */}
        <Tooltip title="Back">
          <button
            onClick={handleCloseModal}
            className="p-2 rounded-full bg-gray-300 hover:bg-cyan-100 active:bg-cyan-200 transition"
            aria-label="Back"
          >
            <ArrowBackIcon />
          </button>
        </Tooltip>

        {/* Centered Controls: Edit, Add, Delete */}
        <div className="absolute left-1/2 -translate-x-1/2 flex space-x-4">
          <Tooltip title={isEditMode ? "Cancel Edit" : "Edit"}>
            <button
              onClick={() =>
                isEditMode ? handleCancel() : handleEditButtonClick("edit")
              }
              className={`p-2 rounded-full hover:bg-gray-300 transition ${
                isEditMode ? "border border-sss-info" : ""
              }`}
            >
              <ModeIcon
                className={isEditMode ? "text-sss-info" : "text-gray-700"}
              />
            </button>
          </Tooltip>
          <Tooltip title="Add">
            <button
              onClick={handleOpenAddModal}
              className="p-2 rounded-full hover:bg-gray-300 transition"
            >
              <AddIcon className="text-gray-700" />
            </button>
          </Tooltip>
          <Tooltip title="Delete">
            <button
              onClick={handleDelete}
              className="p-2 rounded-full hover:bg-gray-300 active:text-sss-info transition"
              aria-label="Delete"
            >
              <DeleteIcon className="text-gray-700 hover:text-red-500" />
            </button>
          </Tooltip>
        </div>

        {/* Right-Aligned Controls */}
        <div className="flex items-center space-x-2">
          {isEditMode && (
            <div className="mr-2 text-sm text-gray-500">
              {isSaving ? "Saving..." : autosaveStatus || "Saved"}
            </div>
          )}
          <Tooltip title="Open in New Window">
            <button
              className="p-2 hover:bg-gray-300 transition"
              aria-label="Open in New Window"
            >
              <LaunchOutlinedIcon className="text-gray-700" />
            </button>
          </Tooltip>
          <Tooltip title={isExpanded ? "Shrink Modal" : "Expand Modal"}>
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className={`p-2 hover:bg-gray-200 transition ${
                isExpanded ? "text-sss-info" : "text-gray-700"
              }`}
              aria-label={isExpanded ? "Shrink Modal" : "Expand Modal"}
            >
              {isExpanded ? <ShrinkIcon /> : <ExpandIcon />}
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

ViewModalHeader.propTypes = {
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  handleCloseModal: PropTypes.func,
  isEditMode: PropTypes.bool,
  handleEditButtonClick: PropTypes.func,
  handleCancel: PropTypes.func,
  handleDelete: PropTypes.func,
  isSaving: PropTypes.bool,
  autosaveStatus: PropTypes.string,
  handleOpenAddModal: PropTypes.func,
};

export default ViewModalHeader;
